// extracted by mini-css-extract-plugin
export default {"filtersAndSort":"styles_filtersAndSort__34rat","mobileTitle":"styles_mobileTitle__KOfCP"};